// Namespace, Type, Values
Jelly.Actions.Create_On_Submit = function(Parameters) { 	
	var Input_Alias = "Create_On_Submit";

	// Get current value if it exists
	var Value_Input = $(Jelly.Actions.Get_Input_From_Action_By_Alias({
		Namespace: Parameters["Namespace"], 
		Alias: Input_Alias
	}));
	
	var Current_Create_On_Submit_Value;
	if (Value_Input.length)
		Current_Create_On_Submit_Value = JSON.parse(Value_Input.val());
	else 
		Current_Create_On_Submit_Value  = [];

	// Add new item to current value
	Current_Create_On_Submit_Value.push({
		Type: Parameters["Type"],
		Data: Parameters["Values"]
	});

	// Add value to DOM
	// Namespace, Input_Alias, Value
	Jelly.Actions.Add_Hidden_Value({
		Namespace: Parameters["Namespace"],
		Input_Alias: Input_Alias,
		Value: JSON.stringify(Current_Create_On_Submit_Value)
	});
};